<template>
  <div class="sub-page">
    <h2 class="page-title">课程概述</h2>
    <p class="page-desc">
      《液压与气压传动技术》是机械类和相关专业的一门专业基础必修课程，具有重要的地位和作用。课程内容涉及液压和气压传动系统的基本组成，以及“能源（动力）装置—执行装置（机构）—控制调节装置—辅助装置—工作介质”等基本组成部分的结构组成和工作原理，讲述传动系统的工作过程。主要内容包括：绪论、流体力学基础、液压泵、液压马达、液压缸、液压阀、辅助元件、液压基本回路、典型液压系统、气压传动等方面知识。<br><br>
      在教学方法上，坚持“以学生为中心、以能力培养为导向、持续质量改进”为理念，在“理实虚用、四位一体”教学改革思想指导下，践行全时空“VR+教学”模式；在教学手段上，充分运用VR技术，将VR教学资源、3D版教材，VR教学云平台等要素融入教学的各个环节，为学生提供立体可视化的沉浸、交互式的学习空间，增强学生的工程认识和实践，激发学生的创造性思维，让学生对知识产生兴趣，提高学生的知识吸收率。<br><br>
      通过课程的学习，引导学生主动肩负制造强国的历史使命，提高工程综合素养，为学习其他相关专业课程，从事机械设计和加工制造等工作，奠定坚实的基础。
    </p>

    <h3 class="page-subtitle" style="font-size: 20px; margin: 24px 0; border-bottom: 1px solid #f0f2f5; padding-bottom: 8px;">授课目标</h3>
    <ul class="objective-list" style="list-style: decimal inside; padding-left: 20px;">
      <li>了解液压与气压传动技术的应用发展，掌握其工作原理、系统基本组成及特点；掌握流体力学相关理论知识，具备正确选用液压油的能力以及推导实际应用问题的静、动力学模型的能力，并能根据流体流动的状态，对流体在系统管道中能量损耗进行计算，具备初步分析液压与气压系统传递效率的能力。</li>
      <li>掌握各类液压和气压元件的基本结构、工作原理、应用场合以及液压元件的性能参数，能够分析液压和气压基本回路，具备进行元件选择和相关计算的能力，以及液压和气压基本回路初步设计的能力。</li>
      <li>能够分析液压和气压系统的工作原理、工作过程、系统中各元件的作用及客观评价系统优缺点；具备综合运用液压和气压传动基本知识，提出满足特定需求的液压与气压传动系统的合理设计方案的能力，并体现创新意识。</li>
      <li>掌握必要的实验技能，能够制定实验方案，具备利用实验对液压系统性能进行研究的能力，并具备正确处理实验数据以及撰写实验报告的能力。</li>
    </ul>

    <h3 class="page-subtitle" style="font-size: 20px; margin: 24px 0; border-bottom: 1px solid #f0f2f5; padding-bottom: 8px;">参考资料</h3>
    <ul class="reference-list" style="list-style: disc inside; padding-left: 20px;">
      <li>[1] 陈清奎等编著. 液压与气压传动技术（3D版）[M]. 北京：机械工业出版社, 2023.</li>
      <li>[2] 左建民主编，《液压传动与其压传动》（第五版）[M]. 北京: 机械工业出版社, 2021.</li>
      <li>[3] 刘银水，许福玲编，《液压传动与其压传动》（第四版）[M]. 北京: 机械工业出版社，2017.</li>
      <li>[4] 游有鹏，李成刚编，《液压传动与其压传动》（第三版）[M]. 北京: 科学出版社，2023.</li>
    </ul>


  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    }
  }
</script>

<style scoped>
  .sub-page {
    padding: 32px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.05);
  }

  .page-title {
    font-size: 24px;
    margin-bottom: 24px;
    border-bottom: 2px solid #f0f2f5;
    padding-bottom: 12px;
  }

  .page-subtitle {
    color: #333;
  }

  .objective-list, .reference-list {
    margin: 16px 0;
  }

  .teacher-list {
    margin-top: 32px;
  }

  .teacher-card {
    display: flex;
    align-items: flex-start;
    gap: 24px;
    padding: 24px 0;
    border-bottom: 1px solid #f0f2f5;
  }

  .teacher-avatar {
    width: 100px;
    height: 100px;
    border-radius: 8px;
    object-fit: cover;
  }

  .teacher-info {
    flex: 1;
  }

  .teacher-name {
    font-size: 18px;
    margin-bottom: 8px;
  }

  .teacher-title {
    color: #666;
    margin-bottom: 4px;
  }

  .teacher-intro {
    color: #999;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tp/OverviewPage.vue